import {
  BarChartOutlined,
  CheckOutlined,
  FieldTimeOutlined,
  HistoryOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  QuestionCircleOutlined,
  ReconciliationOutlined,
  SearchOutlined,
  UserOutlined,
  NodeExpandOutlined,
  ProductOutlined
} from '@ant-design/icons'
import { Button, Input, Menu } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import ROUTER from 'services/router'
import useGetCustomerData from 'state/customer/hooks/useGetCustomerData'
import styled from 'styled-components'
import { numberWithCommas } from 'utils'
import * as qs from 'query-string'


const { Search } = Input

const heightHeader = '70px'

const WrapperHeader = styled.div`
  position: relative;
  z-index: 10;
  padding-left: 250px;
  background-color: #056638;

  .content-header {
    position: fixed;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-left: 0;
    height: ${heightHeader};
    padding-left: 15px;
    padding-right: 15px;
    background: rgb(255, 255, 255);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 1px 2px 0px;
    gap: 12px;

    ${({ theme }) => theme.mediaQueries.md} {
      padding-left: 2rem;
      padding-right: 2rem;
    }

    ${({ theme }) => theme.mediaQueries.lg} {
      width: calc(100vw - 250px);
    }

    .wrap-search {
      display: flex;
      align-items: center;
      width: 100%;

      h4 {
        margin-right: 10px;

        ${({ theme }) => theme.mediaQueries.lg} {
          margin-right: 25px;
        }
      }

      button {
        &:not(:last-child) {
          margin-right: 10px;

          ${({ theme }) => theme.mediaQueries.lg} {
            margin-right: 25px;
          }
        }
      }

      .wrap-price {
        font-size: 1.5rem;
      }
    }

    .btn-open-menu {
      background: none;
      border: none;

      ${({ theme }) => theme.mediaQueries.lg} {
        display: none;
      }
    }
  }

  .clone-header {
    height: ${heightHeader};
  }
`

const ContentMenu = styled.div`
  .content-menu {
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    width: 250px;
    background-color: #056638;
    min-height: 100vh;
    height: 100%;
    overflow: auto;
    transform: translateX(-100%);
    transition: 0.25s;

    &.active {
      transform: translateX(0);
    }

    ${({ theme }) => theme.mediaQueries.lg} {
      transform: translateX(0);
    }

    .logo-menu {
      text-align: center;
      padding: 10px 20px 20px 20px;

      img {
        background: #fff;
        border-radius: 50%;
      }
    }

    .ant-menu-inline > .ant-menu-item {
      height: 30px !important;
    }

    .ant-menu {
      background-color: #056638;

      .ant-menu-inline.ant-menu-sub {
        background-color: #056638;
      }

      &:not(.ant-menu-horizontal) {
        .ant-menu-item-selected {
          background-color: transparent;
          .ant-menu-title-content {
            font-weight: bold;
            color: #fff;
            a {
              font-weight: bold;
              color: #fff;
            }
          }
        }
      }

      .ant-menu-title-content {
        color: #d3d1ff;
          font-weight: 400;

        a {
          color: #d3d1ff;
          font-weight: 400;
        }
      }
    }

    .button-create-order {
      background: transparent;
      text-align: center;
      border: 1px solid #008848;
      width: calc(100% - 20px);

      &:hover {
        background: var(--button-primary-color);
        border-color: var(--button-primary-color);
      }
    }
  }
`

const UserMenu = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;

  .user-icon {
    font-size: 16px;
  }
`

const UserWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  min-width: 100px;
  cursor: pointer;

  a {
    display: block;
  }

  p {
    font-size: 12px;
    text-align: right;
  }

  ${({ theme }) => theme.mediaQueries.xs} {
    width: max-content;
  }
`

const WrapperHeaderPrivate = styled.div``

const HeaderPrivate = () => {
  const history = useHistory()
  const location = useLocation()
  const { customerProfile } = useGetCustomerData()

  const [searchValue, setSearchValue] = useState<any>('')
  const [collapsed] = useState(false)
  const [active, setActiveMenu] = useState<string>(ROUTER.adminHome)
  const [open, setOpenMenu] = useState<boolean>(false)
  const { keyword } = qs.parse(location.search)

  useEffect(() => {
    if (location.pathname) {
      setActiveMenu(location.pathname)
    }
  }, [location.pathname])

  const handelLink = (link: string) => {
    if (location.pathname === link) {
      window.location.href = link;
      return;
    }
    setOpenMenu(false)
  }

  const onSearch = useCallback(
    (e) => {
      window.location.href = `/tim-kiem-don-van?keyword=${e}`
    },
    [history]
  )

  useEffect(() => {
    if (location?.pathname === '/tim-kiem-don-van') {
      setSearchValue(keyword)
      return
    }
    setSearchValue("")
  }, [location?.pathname, keyword])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location?.pathname])

  return (
    <WrapperHeaderPrivate>
      <>
        <WrapperHeader>
          <div className='content-header'>
            <div className='wrap-search'>
              <Search
                allowClear
                value={searchValue}
                style={{ maxWidth: 500, width: '100%' }}
                placeholder='Nhập mã đơn vận, tên người nhận, số điện thoại người nhận...'
                onSearch={onSearch}
                onChange={(e) => setSearchValue(e?.target?.value)}
                onPressEnter={(e: any) => onSearch(e?.target?.value)}
              />
            </div>

            <UserMenu>
              <UserWrapper>
                <Link to={ROUTER.profile}>
                  <p>
                    <UserOutlined className='user-icon' /> {customerProfile?.full_name}
                  </p>
                  <p>Ký quỹ: <span className='bold'>{customerProfile ? numberWithCommas(customerProfile?.marginBalance?.margin_balance) : '--'}đ</span></p>
                </Link>
              </UserWrapper>

              <button className='btn-open-menu' type='button' onClick={() => setOpenMenu((prev) => !prev)}>
                {open ? <MenuUnfoldOutlined style={{ fontSize: '26px' }} /> : <MenuFoldOutlined style={{ fontSize: '26px' }} />}
              </button>
            </UserMenu>
          </div>
          <div className='clone-header' />
        </WrapperHeader>

        <ContentMenu>
          <div className={`content-menu ${open ? 'active' : ''}`}>
            <div className='logo-menu'>
              <Link to='/'>
                <img src='/logo.png' width={80} alt='' />
              </Link>
            </div>

            <div style={{ textAlign: 'center', marginBottom: 10 }}>
              <Button className='button-create-order' style={{ color: '#fff' }}>
                <Link
                  onClick={() => handelLink(ROUTER.orderCreate)}
                  to={ROUTER.orderCreate}> ĐƠN HÀNG MỚI </Link>
              </Button>
            </div>

            <Menu selectedKeys={[active]} defaultOpenKeys={['menu-swap']} mode='inline' theme='dark' inlineCollapsed={collapsed}>
              <Menu.Item key={ROUTER.adminHome} icon={<MenuOutlined />}>
                <Link
                  onClick={() => handelLink(ROUTER.adminHome)}
                  to={ROUTER.adminHome}> MÀN HÌNH CHÍNH </Link>

              </Menu.Item>
              <Menu.Item key={ROUTER.orderTracking} icon={<SearchOutlined />}>
                <Link
                  onClick={() => handelLink(ROUTER.orderTracking)}
                  to={ROUTER.orderTracking}> ĐƠN ĐANG XỬ LÝ</Link>
              </Menu.Item>
              <Menu.Item
                key={ROUTER.historyChangeWeigth}
                icon={<HistoryOutlined />}
              >
                <Link
                  onClick={() => handelLink(ROUTER.historyChangeWeigth)}
                  to={ROUTER.historyChangeWeigth}>  LỊCH SỬ ĐIỀU CHỈNH K/L</Link>
              </Menu.Item>
              <Menu.Item
                key={ROUTER.orderChangeWeight}
                icon={<ReconciliationOutlined />}
              >
                <Link
                  onClick={() => handelLink(ROUTER.orderChangeWeight)}
                  to={ROUTER.orderChangeWeight}> ĐƠN ĐIỀU CHỈNH K/L</Link>
              </Menu.Item>
              <Menu.Item
                key={ROUTER.customerSupport}
                icon={<QuestionCircleOutlined />}
              >
                <Link
                  onClick={() => handelLink(ROUTER.customerSupport)}
                  to={ROUTER.customerSupport}>HỖ TRỢ KHÁCH HÀNG</Link>
              </Menu.Item>
              <Menu.Item key={ROUTER.orderHistory} icon={<CheckOutlined />}>
                <Link
                  onClick={() => handelLink(ROUTER.orderHistory)}
                  to={ROUTER.orderHistory}>ĐƠN VẬN HOÀN TẤT</Link>
              </Menu.Item>
              <Menu.Item key={ROUTER.manageProduct} icon={<ProductOutlined />}>
                <Link to={ROUTER.manageProduct}
                  onClick={() => handelLink(ROUTER.manageProduct)}>QUẢN LÝ SẢN PHẨM </Link>
              </Menu.Item>
              <Menu.Item key={ROUTER.finacialReport} icon={<BarChartOutlined />}>
                <Link to={ROUTER.finacialReport}
                  onClick={() => handelLink(ROUTER.finacialReport)}>BÁO CÁO TÀI CHÍNH</Link>
              </Menu.Item>
              <Menu.Item key={ROUTER.escrowHisotry} icon={<FieldTimeOutlined />}>
                <Link to={ROUTER.escrowHisotry}
                  onClick={() => handelLink(ROUTER.escrowHisotry)}>LỊCH SỬ KÝ QUỸ</Link>
              </Menu.Item>
              <Menu.Item key={ROUTER.reconciliationHistory} icon={<NodeExpandOutlined />}>
                <Link to={ROUTER.reconciliationHistory}
                  onClick={() => handelLink(ROUTER.reconciliationHistory)}>LỊCH SỬ ĐỐI SOÁT</Link>
              </Menu.Item>
            </Menu>
          </div>
        </ContentMenu>
      </>
    </WrapperHeaderPrivate>
  )
}

export default HeaderPrivate
